module.exports = __webpack_public_path__ + "static/img/chart-pic4.40475a8f.png";